var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 41.5C29.7874 41.5 30.8302 41.068 31.5991 40.2991C32.368 39.5302 32.8 38.4874 32.8 37.4V27.15L22.55 35.35V29.2H8.2V25.1H22.55V18.95L32.8 27.15V12.8L20.5 0.5H4.1C3.01261 0.5 1.96976 0.931963 1.20086 1.70086C0.431963 2.46976 0 3.51261 0 4.6V37.4C0 38.4874 0.431963 39.5302 1.20086 40.2991C1.96976 41.068 3.01261 41.5 4.1 41.5H28.7ZM18.45 4.6L28.7 14.85H18.45V4.6Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportImage);
export default __webpack_public_path__ + "static/media/Export-image.2a31fe946b7cc0ad7af7b3342010052f.svg";
export { ForwardRef as ReactComponent };